import { ReactElement } from 'react';

import { ComputeResourceType } from '@cast/shared-types';

import { ResourcesSimulationChart } from './_components/ResourcesSimulationChart';
import { SimulationContainer } from './_components/SimulationContainer';
import { useSimulationSettings } from './_components/useSimulationSettings';
import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

const Simulations = () => {
  const { cpu, memory } = useSimulationSettings();

  return (
    <>
      <ResourcesSimulationChart
        testId="overhead-simulation-cpu"
        type={ComputeResourceType.CPU}
        seed="scaling-policy-simulation-overhead-cpu"
        percentile={cpu.percentile}
        overhead={cpu.overhead}
      />

      <ResourcesSimulationChart
        testId="overhead-simulation-memory"
        type={ComputeResourceType.MEMORY}
        seed="scaling-policy-simulation-overhead-memory"
        percentile={memory.percentile}
        overhead={memory.overhead}
      />
    </>
  );
};

type Props = {
  overheadField: ReactElement;
};
export const OverheadSettingsContainer = ({ overheadField }: Props) => {
  const { title, description, docsLinkKey, simulation } =
    vpaSettingsConstants.overhead;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
      bottomContent={
        <SimulationContainer description={simulation.description}>
          <Simulations />
        </SimulationContainer>
      }
    >
      {overheadField}
    </VerticalSettingsForm>
  );
};
